import React from 'react';
import './LegalModal.css';

interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
  theme: 'light' | 'dark';
}

export const PrivacyModal: React.FC<PrivacyModalProps> = ({
  isOpen,
  onClose,
  theme,
}) => {
  if (!isOpen) return null;

  return (
    <div className="legal-modal-overlay" onClick={onClose}>
      <div className="legal-modal" onClick={e => e.stopPropagation()}>
        <div className="legal-modal-header">
          <h2>개인정보처리방침</h2>
          <button className="legal-modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="legal-modal-content">
          <div className="legal-intro">
            <p>
              차트 트레이너('이하 '서비스')는 개인정보보호법에 따라 이용자의
              개인정보 보호 및 권익을 보호하고자 다음과 같은 처리방침을 두고
              있습니다.
            </p>
            <p>본 방침은 2026년 2월 1일부터 시행되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
          </div>

          <div className="legal-section">
            <h3>1. 개인정보의 처리 목적</h3>
            <p>
              서비스는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는
              개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용
              목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의
              동의를 받는 등 필요한 조치를 이행할 예정입니다.
            </p>
            <ul>
              <li>
                <strong>회원 가입 및 관리:</strong> 회원 가입, 본인 식별·인증, 회원 자격
                유지·관리, 서비스 부정이용 방지 목적
              </li>
              <li>
                <strong>서비스 제공:</strong> 가상 투자 시뮬레이션 게임 서비스, 랭킹 시스템, 매매내역 관리 및 제공
              </li>
              <li>
                <strong>고객 지원:</strong> 문의사항 응대, 서비스 개선을 위한 피드백 수집
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>2. 수집하는 개인정보의 항목 및 수집 방법</h3>
            <p>
              서비스는 회원가입, 서비스 이용을 위해 다음과 같은 개인정보를 수집합니다.
            </p>
            
            <h4>2.1 수집하는 개인정보 항목</h4>
            <ul>
              <li>
                <strong>필수 항목:</strong> 이메일 주소
              </li>
              <li>
                <strong>선택 항목:</strong> 닉네임 (서비스 이용을 위한 표시명)
              </li>
              <li>
                <strong>자동 수집 항목:</strong> IP 주소, 쿠키, 서비스 이용 기록, 접속 로그
              </li>
            </ul>

            <h4>2.2 개인정보 수집 방법</h4>
            <ul>
              <li>
                <strong>일반 회원가입:</strong> 이메일 주소, 비밀번호(해시화하여 저장), 닉네임을 직접 입력받아 수집합니다.
              </li>
              <li>
                <strong>카카오 소셜 로그인:</strong> 카카오 계정을 통한 로그인 시, 카카오로부터 이메일 주소와 닉네임을 제공받아 수집합니다. 
                카카오 계정에 이메일이 없는 경우, 카카오 고유 ID를 기반으로 서비스 내 이메일을 생성하여 사용합니다.
              </li>
              <li>
                <strong>자동 수집:</strong> 서비스 이용 과정에서 자동으로 생성되어 수집되는 정보(IP 주소, 쿠키, 서비스 이용 기록 등)
              </li>
            </ul>

            <p>
              <strong>※ 비밀번호 보관:</strong> 일반 회원가입 시 입력하신 비밀번호는 암호화(해시화)하여 저장하며, 
              원문은 저장하지 않습니다. 카카오 로그인을 사용하는 경우 비밀번호를 수집하지 않습니다.
            </p>
          </div>

          <div className="legal-section">
            <h3>3. 개인정보의 처리 및 보유기간</h3>
            <p>
              서비스는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터
              개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서
              개인정보를 처리·보유합니다.
            </p>
            <ul>
              <li>
                <strong>회원 정보 (이메일, 닉네임):</strong> 회원 탈퇴 시까지 보관합니다. 
                단, 관련 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관합니다.
              </li>
              <li>
                <strong>게임 기록 및 랭킹 정보:</strong> 서비스 제공 기간 동안 보관합니다.
              </li>
              <li>
                <strong>로그인 기록, 접속 로그:</strong> 서비스 제공 기간 동안 보관합니다.
              </li>
            </ul>
            <p>
              회원 탈퇴 시 개인정보는 즉시 삭제되며, 삭제된 정보는 복구할 수 없습니다. 
              다만, 관련 법령에 따라 일정 기간 보관이 필요한 경우 해당 기간 동안 보관 후 삭제합니다.
            </p>
          </div>

          <div className="legal-section">
            <h3>4. 개인정보의 제3자 제공</h3>
            <p>
              서비스는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 
              다만, 다음의 경우에는 예외로 합니다:
            </p>
            <ul>
              <li>이용자가 사전에 동의한 경우</li>
              <li>
                법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와
                방법에 따라 수사기관의 요구가 있는 경우
              </li>
            </ul>
            <p>
              <strong>※ 카카오 로그인:</strong> 카카오 소셜 로그인을 이용하는 경우, 
              카카오의 개인정보처리방침이 적용됩니다. 서비스는 카카오로부터 제공받은 
              이메일과 닉네임만을 수집하며, 카카오에 개인정보를 제공하지 않습니다.
            </p>
          </div>

          <div className="legal-section">
            <h3>5. 개인정보의 파기</h3>
            <p>
              서비스는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가
              불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
            </p>
            <ul>
              <li>
                <strong>파기 방법:</strong> 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
              </li>
              <li>
                <strong>파기 시점:</strong> 회원 탈퇴 시 즉시 파기하며, 법령에 따라 보관이 필요한 경우 해당 기간 경과 후 파기합니다.
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>6. 정보주체의 권리·의무 및 그 행사방법</h3>
            <p>
              이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다:
            </p>
            <ul>
              <li>개인정보 열람요구</li>
              <li>개인정보 정정·삭제요구</li>
              <li>개인정보 처리정지 요구</li>
              <li>회원 탈퇴 (개인정보 삭제)</li>
            </ul>
            <p>
              위 권리 행사는 서비스 내 마이페이지를 통해 직접 처리하거나, 
              서비스 운영자에게 이메일을 통해 요청하실 수 있으며, 서비스는 이에 대해 지체 없이
              조치하겠습니다.
            </p>
          </div>

          <div className="legal-section">
            <h3>7. 개인정보의 안전성 확보 조치</h3>
            <p>
              서비스는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다:
            </p>
            <ul>
              <li>
                <strong>관리적 조치:</strong> 내부관리계획 수립·시행, 정기적 직원 교육 등
              </li>
              <li>
                <strong>기술적 조치:</strong> 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 
                비밀번호 암호화(해시화) 저장 등
              </li>
              <li>
                <strong>물리적 조치:</strong> 전산실, 자료보관실 등의 접근통제
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>8. 개인정보 보호책임자</h3>
            <p>
              서비스는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
              처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와
              같이 개인정보 보호책임자를 지정하고 있습니다.
            </p>
            <ul>
              <li><strong>개인정보 보호책임자:</strong> 마니후</li>
              <li><strong>이메일:</strong> <a href="mailto:mastermanihoo@gmail.com">mastermanihoo@gmail.com</a></li>
            </ul>
            <p>
              정보주체께서는 서비스의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 
              문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다.
            </p>
          </div>

          <div className="legal-section">
            <h3>9. 개인정보 처리방침 변경</h3>
            <p>
              이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른
              변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일
              전부터 공지사항을 통하여 고지할 것입니다.
            </p>
          </div>

          <div className="legal-section">
            <h3>10. 쿠키의 운영 및 거부</h3>
            <p>
              서비스는 이용자에게 개인화된 서비스를 제공하기 위해 쿠키를 사용할 수 있습니다. 
              쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 컴퓨터 브라우저에 보내는 
              소량의 정보이며 이용자의 컴퓨터 하드디스크에 저장됩니다.
            </p>
            <ul>
              <li>
                <strong>쿠키의 사용 목적:</strong> 로그인 세션 유지, 서비스 이용 환경 설정 등
              </li>
              <li>
                <strong>쿠키 설정 거부:</strong> 이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 
                웹브라우저 설정에서 쿠키 허용 여부를 선택할 수 있습니다. 다만, 쿠키 설치를 거부할 경우 
                서비스 이용에 어려움이 있을 수 있습니다.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

